(() => {
  // A section can be replaced in the theme editor without reloading the document.
  if (window.afsContactInitialized) return;
  window.afsContactInitialized = true;
  let activeRoot;
  let cleanup = () => {};
  const init = () => {
    const root = document.querySelector('[data-afs-floating]');
    if (root === activeRoot && root?.isConnected) return;
    cleanup();
    activeRoot = root;
    if (!root) return;
    const controller = new AbortController();
    const greeting = root.querySelector('[data-afs-welcome]');
    const back = root.querySelector('[data-afs-back-top]');
    let dismissed = false;
    try { dismissed = sessionStorage.getItem('afs-welcome-dismissed') === '1'; } catch {}
    const timer = greeting && !dismissed ? setTimeout(() => { greeting.hidden = false; }, 1600) : null;
    root.querySelector('[data-afs-dismiss]')?.addEventListener('click', () => {
      if (greeting) greeting.hidden = true;
      try { sessionStorage.setItem('afs-welcome-dismissed', '1'); } catch {}
    }, { signal: controller.signal });
    const sync = () => {
      if (back) back.hidden = window.scrollY < 450;
      const sticky = document.querySelector('.sticky-add-to-cart__bar[data-stuck="true"]');
      root.style.setProperty('--afs-bottom-offset', sticky ? `${sticky.getBoundingClientRect().height + 18}px` : (innerWidth <= 600 ? '14px' : '24px'));
      const openMenu = [...document.querySelectorAll('.afs-mobile-nav>details[open]')].some(menu => menu.getClientRects().length > 0);
      const editingForm = document.activeElement?.matches('.afs-inquiry input,.afs-inquiry textarea,.afs-footer input');
      root.classList.toggle('afs-floating--blocked', !!document.querySelector('dialog[open]') || openMenu || (innerWidth <= 600 && editingForm));
    };
    window.addEventListener('scroll', sync, { passive: true, signal: controller.signal });
    window.addEventListener('resize', sync, { passive: true, signal: controller.signal });
    document.addEventListener('focusin', sync, { signal: controller.signal });
    document.addEventListener('focusout', () => queueMicrotask(sync), { signal: controller.signal });
    back?.addEventListener('click', () => window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }), { signal: controller.signal });
    const observer = new MutationObserver(sync);
    observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open', 'data-stuck', 'data-menu-style'] });
    cleanup = () => { clearTimeout(timer); controller.abort(); observer.disconnect(); };
    sync();
  };
  const prefill = () => {
    const params = new URLSearchParams(location.search);
    const name = params.get('inquiry_product');
    const url = params.get('inquiry_url');
    if (!name) return;
    document.querySelectorAll('[data-afs-inquiry-body]').forEach(field => {
      if (!field.value.trim()) field.value = 'Product: ' + name + (url ? '\nLink: ' + url : '') + '\nQuantity: \nCustom requirements: \nDelivery country: ';
    });
  };
  const closeHiddenMenus = () => {
    document.querySelectorAll('.afs-mobile-nav,.afs-desktop-nav').forEach(nav => {
      const headerHidden = nav.closest('#header-component')?.dataset.stickyState === 'idle';
      if (nav.getClientRects().length && !headerHidden) return;
      const restoreFocus = nav.contains(document.activeElement);
      nav.querySelectorAll('[data-afs-nav][open]').forEach(details => { details.open = false; });
      if (restoreFocus && headerHidden) document.activeElement?.blur();
      else if (restoreFocus) {
        const mobileTrigger = document.querySelector('.afs-mobile-nav>details>summary');
        (mobileTrigger?.getClientRects().length ? mobileTrigger : document.querySelector('#header-component .header-logo'))?.focus();
      }
    });
  };
  let navObserver;
  const observeNavigation = () => {
    navObserver?.disconnect();
    const header = document.querySelector('#header-component');
    if (!header) return;
    navObserver = new MutationObserver(closeHiddenMenus);
    navObserver.observe(header, { attributes: true, attributeFilter: ['data-menu-style', 'data-sticky-state'] });
    closeHiddenMenus();
  };
  window.addEventListener('resize', () => requestAnimationFrame(closeHiddenMenus), { passive: true });
  const setup = () => { init(); prefill(); observeNavigation(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', () => { if (activeRoot && !activeRoot.isConnected) { cleanup(); activeRoot = null; } });
  document.addEventListener('variant:update', event => {
    const scope = event.target instanceof Element ? event.target.closest('[data-testid="product-information"]') : null;
    const panel = scope?.querySelector('[data-afs-product-quote]');
    const source = event.detail?.data?.html;
    if (!panel || !source?.querySelectorAll) return;
    const updated = [...source.querySelectorAll('[data-afs-product-quote]')].find(node => node.dataset.productId === panel.dataset.productId);
    if (!updated) return;
    const next = document.importNode(updated, true);
    // An unavailable combination has no variant; do not quote an unrelated default size/color.
    if (!event.detail.resource) {
      const inquiry = next.querySelector('.afs-product-quote');
      const whatsapp = next.querySelector('a[href^="https://wa.me/"]');
      if (inquiry) {
        const href = new URL(inquiry.href, location.origin);
        href.searchParams.set('inquiry_product', next.dataset.productTitle);
        href.searchParams.set('inquiry_url', next.dataset.productUrl);
        inquiry.href = href.pathname + href.search + href.hash;
      }
      if (whatsapp) {
        const href = new URL(whatsapp.href);
        href.searchParams.set('text', 'Hi, I would like to discuss customization for ' + next.dataset.productTitle + '. Product: ' + next.dataset.productUrl);
        whatsapp.href = href.href;
      }
    }
    panel.replaceWith(next);
  });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    document.querySelectorAll('[data-afs-nav][open]').forEach(details => {
      if (!details.contains(event.target) || event.target.closest('a')) details.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const focused = document.activeElement?.closest('[data-afs-nav][open]');
    if (focused) {
      focused.open = false;
      focused.querySelector(':scope > summary')?.focus();
      event.preventDefault();
    } else document.querySelectorAll('[data-afs-nav][open]').forEach(details => { details.open = false; });
  });
})();
